import React from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { isMobile, mysqlDateToArabic } from "../../helpers";
import { Table } from "../../lib";
import { fetchDocs } from "../../reducers/docs/actions";
import Actions from "./Actions";
import { AppState } from "../../store";
import { RowProps } from "../../lib/ui/Table";

export const Container = styled.div`
    width: 100%;
`;

const mapStateToProps = ({ docs }: AppState) => ({ docs });
const mapDispatch = {
    fetchDocs,
};
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatch;
type OwnProps = {
    filter: string;
};
type Props = StateProps & DispatchProps & OwnProps;
type State = {
    selected: number[];
};

class List extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            selected: [],
        };
    }

    async componentDidMount() {
        this.props.fetchDocs("");
    }

    onRowClick = (row: RowProps) => {
        const doc_id = row.id as number;
        let { selected } = this.state;

        if (selected.includes(doc_id)) {
            selected.splice(selected.indexOf(doc_id), 1);
        } else {
            selected.push(doc_id);
        }

        this.setState({ selected: selected.slice() });
    };

    isSelected = (row: RowProps) =>
        this.state.selected.includes(row.id as number);

    table() {
        const { docs, filter } = this.props;
        let fields = ["name", "updated_at"];
        let titles = ["docForm.name", "docForm.lastUpdated"];

        let width = ["80%", "20%"];
        if (isMobile()) {
            fields = ["name"];
            titles = ["docForm.name"];
            width = ["100%"];
        }

        const transform = {
            updated_at: mysqlDateToArabic,
        };

        const rows = docs
            //@ts-ignore
            .filter((d: any) =>
                filter ? d.get("name").includes(filter) : true
            )
            .toList()
            .sort(
                (a: any, b: any) =>
                    new Date(b.get("updated_at")).getTime() -
                    new Date(a.get("updated_at")).getTime()
            )
            .slice(0, 10);

        if (rows.size === 0) {
            return null;
        }

        return (
            <Table
                width={width}
                titles={titles}
                fields={fields}
                transform={transform}
                rows={rows.toJS()}
                isSelected={this.isSelected}
                onRowClick={this.onRowClick}
            />
        );
    }

    clearSelected = () => this.setState({ selected: [] });

    render() {
        const { docs } = this.props;
        // @ts-ignore
        if (docs.size === 0) {
            return null;
        }

        return (
            <Container>
                <Actions
                    selected={this.state.selected}
                    clearSelected={this.clearSelected}
                />
                {this.table()}
            </Container>
        );
    }
}

export default connect(mapStateToProps, mapDispatch)(List);
